"use client";

import React, { useState } from "react";
import { Button } from "@heroui/button";
import { HeartIcon } from "@/public/icons/HeartIcon";
import { toggleLike } from "@/src/app/hooks/content.hooks";

export default function LikeButton({ isLiked, postId, token }) {
  const [like, setLike] = useState(isLiked);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleToggleLike = async () => {
    setIsDisabled(true);
    try {
      const response = await toggleLike(token, postId);

      if (response.status === 200) {
        console.log(response);
        setLike(response.data.data.liked);
      }
    } catch (error) {
      console.log("Error Occurred when liking this post.");
    }
    setIsDisabled(false);
  };

  const buttonStyle = `inline-flex items-center px-4 py-2 border rounded text-sm font-medium focus:outline-none transition ease-in-out duration-150 ${
    like
      ? "bg-1B51CA text-white border-1B51CA"
      : "text-1B51CA bg-E6E6E6 hover:bg-blue-50"
  }`;

  return (
    <Button
      size="sm"
      aria-label={like ? "Liked" : "Like"}
      className={buttonStyle}
      onPress={handleToggleLike}
      disabled={isDisabled}
    >
      <HeartIcon filled={like} fill={like ? "red" : "white"} size={24} />
      {like ? "Liked" : "Like"}
      {/* Conditional rendering for like count */}
      {/* {likeCount > 0 && <span className="ml-2">{likeCount}</span>} */}
    </Button>
  );
}
